module.exports = __webpack_public_path__ + "img/all-level-ballet-class.995da5fe.png";